import {ApcDateListWithStables} from 'api/gen/ApcDateListWithStables';
import {ApcStableDate} from 'api/gen/ApcStableDate';
import {ApcStableListWithDates} from 'api/gen/ApcStableListWithDates';

/**
 * Narrows APC stable/date unions to the protocol-backed variant.
 *
 * @param x APC stable/date union value.
 * @returns `true` when the payload is `ApcDateListWithStables`.
 */
export const isApcDateListWithStables = (x: ApcStableDate): x is ApcDateListWithStables =>
    x.tag === 'ApcDateListWithStables';

/**
 * Narrows APC stable/date unions to the stable-list variant.
 *
 * @param x APC stable/date union value.
 * @returns `true` when the payload is `ApcStableListWithDates`.
 */
export const isApcStableListWithDates = (x: ApcStableDate): x is ApcStableListWithDates =>
    x.tag === 'ApcStableListWithDates';
